<template>
  <div class="ui-banner bg-secondary cursor-pointer !p-2 relative">
    <p class="!text-sm" v-text="latestMessage"/>
    <small class="text-slate-400" v-text="moment(latestUpdated).format('Y-m-d - H:m')"/>

    <div
      v-if="unread_count"
      class="absolute right-2 top-2 bg-red-500 aspect-square h-6 rounded-full text-white text-center"
      v-text="unread_count"
      />
  </div>
</template>

<script setup lang="ts">
import moment from 'moment';

const {
  latestMessage,
  latestUpdated,
  unread_count
} = defineProps<{
  session: string,
  latestMessage: string,
  latestUpdated: string,
  unread_count: number|null
}>()

</script>
